
export const RECEIVED_NOTES = "RECEIVED_NOTES";
export const SET_NOTE = "SET_NOTE";
export const CREATE_NOTE = "CREATE_NOTE";
export const SET_PROPERTY_NOTE = "SET_PROPERTY_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
